export default "__VITE_ASSET__CwNL6_Cz__"